<script setup lang="ts"></script>

<template>
  <v-empty-state
    headline="Oops, 404!"
    title="Page introuvable"
    text="Es-tu sûr que t'es pas dans le champ du voisin?"
    icon="custom:wizard-onion"
  />
</template>
